import { render, staticRenderFns } from "./Insentif.vue?vue&type=template&id=030cc7d8&scoped=true"
import script from "./Insentif.vue?vue&type=script&lang=js"
export * from "./Insentif.vue?vue&type=script&lang=js"
import style0 from "./Insentif.vue?vue&type=style&index=0&id=030cc7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030cc7d8",
  null
  
)

export default component.exports